import React, {useEffect} from 'react';
import {
  FaBell,
  FaCog,
  FaCommentAlt,
  FaGratipay,
  FaPhone,
  FaSignOutAlt,
} from 'react-icons/fa';
import {
  Dimensions,
  Text,
  TouchableWithoutFeedback,
  View,
  StyleSheet,
} from 'react-native';
import Emitter from '../components/Emitter';
import {Card} from 'react-native-elements';
import Header from '../components/HomeHeader';
import {clearAll} from '../database/DataBase';

import {useLinkTo} from '@react-navigation/native';

const HEIGHT = Dimensions.get('window').height;
const WIDTH = Dimensions.get('window').width;

export function InfoBar(props) {
  const linkTo = useLinkTo();

  const onPress = () => {
    switch (props.onPressScreen) {
      case 'LogOut':
        Emitter.emit('login', false);
        clearAll();

        // linkTo('/login');
        break;
      case 'faq':
        linkTo('/customers/faq');
        break;
      case 'aboutus':
        linkTo('/customers/aboutus');
        break;
      case 'contactus':
        linkTo('/customers/contact');
        break;
      case 't&c':
        linkTo('/customers/tandc');
        break;
      case 'feedback':
        linkTo('/customers/feedback');
        break;
      default:
        console.log('default');
        break;
    }
  };

  return (
    <TouchableWithoutFeedback onPress={onPress}>
      <Card containerStyle={styles.cardContainerStyle}>
        <View style={styles.cardViewStyle}>
          {props.iconName}

          <Text style={styles.cardTextStyle}>{props.heading}</Text>
        </View>
      </Card>
    </TouchableWithoutFeedback>
  );
}

export default function Settings(props) {
  useEffect(() => {}, []);

  return (
    <View style={styles.viewStyle}>
      <Header navigation={props.navigation} />
      <View style={styles.innerViewStyle}>
        <InfoBar
          navigation={props.navigation}
          onPressScreen={'faq'}
          iconName={<FaGratipay color="white" size={19} />}
          heading={' FAQs'}
        />
        <InfoBar
          navigation={props.navigation}
          onPressScreen={'feedback'}
          iconName={<FaCommentAlt color="white" size={19} />}
          heading={'Feedback '}
        />
        <InfoBar
          navigation={props.navigation}
          onPressScreen={'aboutus'}
          iconName={<FaBell color="white" size={19} />}
          heading={'About us'}
        />
        <InfoBar
          navigation={props.navigation}
          onPressScreen={'contactus'}
          iconName={<FaPhone color="white" size={19} />}
          heading={'Contact us'}
        />
        <InfoBar
          navigation={props.navigation}
          onPressScreen={'t&c'}
          iconName={<FaCog color="white" size={19} />}
          heading={'Terms and Conditions'}
        />
        <InfoBar
          navigation={props.navigation}
          onPressScreen={'LogOut'}
          iconName={<FaSignOutAlt color="white" size={19} />}
          heading={'Logout'}
        />
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  viewStyle: {
    height: HEIGHT,
  },
  innerViewStyle: {alignItems: 'center'},
  cardContainerStyle: {
    padding: 15,
    backgroundColor: '#1c2940',
    borderWidth: 0,
    borderRadius: 10,
    width: WIDTH < 720 ? WIDTH * 0.9 : WIDTH / 2,
  },

  cardViewStyle: {
    flexDirection: 'row',

    alignItems: 'center',
  },
  cardTextStyle: {
    marginHorizontal: 20,
    color: 'white',
    fontFamily: 'Source Sans Pro, sans-serif',
    fontWeight: 'normal',
  },
});
